module.exports = __webpack_public_path__ + "static/media/082.5ae34ee2.jpg";